<template>
    <span class="tag" :class="{
        [theme == undefined ? '' : `tag-${theme}`]: true,
        [tag?.classes]: true
    }">
        <slot name="left-icon">
        </slot>
        {{ tag?.name == 'Специальное' ? '⭐️ СПЕЦИАЛЬНОЕ' : tag?.name }}
        <slot name="right-icon">
        </slot>
    </span>
</template>

<script>
export default {
    name: 'v-tag',
    props: {
        tag: {
            type: Object,
            required: true
        },
        theme: {
            type: String,
            default: '',
            validator(value) {
                return ['', 'red', 'brand', 'special', 'specialization', 'grey', 'outline'].includes(value)
            },
        },
    },
}
</script>

<style lang="scss">

.tag {
    font-size: inherit !important;
    display: inline-flex;
    gap: 0.375em;
    line-height: 1.25;
    align-items: center;
    padding: .25em .625em;
    border-radius: .75em;
    background: #475569;
    color: white;

    transition-property: color, background, background-color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
    &-brand {
        text-transform: uppercase;

        color: #ffffff !important;
        background: #00aea0 !important;
    }
    &-red {
        background: #FBEDED;
        color: #DEA09F;
    }
    /* &-outline {
    } */
    &-grey {
        background: var(--tag-bg-grey-color);
    }
    &-white {
        background: white;
        color: #303098;
    }
    &-premium {
        background: #C7B9FC !important;
    }
    &-specialization {
        color: #00000080;
        background: #00aea00d;
    }
    &-purple-specialization {
        color: #00000080;
        background: rgb(var(--v-theme-purple100));
    }
}

</style>
